module.exports = __webpack_public_path__ + "static/media/smartphone.bd2b1270.svg";